@if (step === 'order-cancel') {
  <app-warning-confirm-box
    [hideCancelBtn]="true"
    [confirmDetailsHeadline]="'cancel_order_headline' | i18next"
    [confirmDetailsText]="'cancel_order_text' | i18next"
    [confirmBtn]="'cancel_order_confirm_button' | i18next" (back)="onBack()"
    (confirm)="onConfirm()"
  ></app-warning-confirm-box>
}
<div class="d-flex justify-content-center mt-5">
  <button
    name="cancel-order-cancel"
    class="btn btn-link"
    (click)="onBack()"
    >
    {{'cancel_order_cancel_button' | i18next}}
  </button>
</div>